import React, {useMemo} from 'react';
import {useTheme} from '../../../theme';
import {BaseResponsiveLayout} from './BaseResponsiveLayout';
import {BaseResponsiveLayoutStyles, ResponsiveLayoutProps} from '../types';
import {mapToBaseProperties} from '../functions';
import {ThemeDeviceNames} from '../../../theme/types/ThemeDevices';

export const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({
  children,
  styles,
}) => {
  const theme = useTheme();

  const baseProps = useMemo(
    () =>
      Object.keys(styles).reduce((acc, key) => {
        const deviceClass = key as keyof ThemeDeviceNames;
        acc[deviceClass] = mapToBaseProperties(theme, styles[deviceClass]);
        return acc;
      }, {} as BaseResponsiveLayoutStyles),
    [theme, styles],
  );
  return (
    <BaseResponsiveLayout styles={baseProps} sizeRanges={theme.devices}>
      {children}
    </BaseResponsiveLayout>
  );
};
